import de from './de.translations.json.js';
import en from './en.translations.json.js';
import es from './es.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import nl from './nl.translations.json.js';
import { portfolioCreateTranslationsDe, portfolioCreateTranslationsEn, portfolioCreateTranslationsEs, portfolioCreateTranslationsFr, portfolioCreateTranslationsIt, portfolioCreateTranslationsNl } from '../portfolio-create/index.js';
import { portfolioDeleteTranslationsDe, portfolioDeleteTranslationsEn, portfolioDeleteTranslationsEs, portfolioDeleteTranslationsFr, portfolioDeleteTranslationsIt, portfolioDeleteTranslationsNl } from '../portfolio-delete/index.js';
import { portfolioEditTranslationsDe, portfolioEditTranslationsEn, portfolioEditTranslationsEs, portfolioEditTranslationsFr, portfolioEditTranslationsIt, portfolioEditTranslationsNl } from '../portfolio-edit/index.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';
import { uiPaginationTranslationsDe, uiPaginationTranslationsEn, uiPaginationTranslationsEs, uiPaginationTranslationsFr, uiPaginationTranslationsIt, uiPaginationTranslationsNl } from '../ui-pagination/index.js';

const portfolioListTranslationsDe = {
  ...de,
  ...portfolioCreateTranslationsDe,
  ...portfolioDeleteTranslationsDe,
  ...portfolioEditTranslationsDe,
  ...localizationSupportTranslationsDe,
  ...uiPaginationTranslationsDe
};
const portfolioListTranslationsEn = {
  ...en,
  ...portfolioCreateTranslationsEn,
  ...portfolioDeleteTranslationsEn,
  ...portfolioEditTranslationsEn,
  ...localizationSupportTranslationsEn,
  ...uiPaginationTranslationsEn
};
const portfolioListTranslationsEs = {
  ...es,
  ...portfolioCreateTranslationsEs,
  ...portfolioDeleteTranslationsEs,
  ...portfolioEditTranslationsEs,
  ...localizationSupportTranslationsEs,
  ...uiPaginationTranslationsEs
};
const portfolioListTranslationsFr = {
  ...fr,
  ...portfolioCreateTranslationsFr,
  ...portfolioDeleteTranslationsFr,
  ...portfolioEditTranslationsFr,
  ...localizationSupportTranslationsFr,
  ...uiPaginationTranslationsFr
};
const portfolioListTranslationsIt = {
  ...it,
  ...portfolioCreateTranslationsIt,
  ...portfolioDeleteTranslationsIt,
  ...portfolioEditTranslationsIt,
  ...localizationSupportTranslationsIt,
  ...uiPaginationTranslationsIt
};
const portfolioListTranslationsNl = {
  ...nl,
  ...portfolioCreateTranslationsNl,
  ...portfolioDeleteTranslationsNl,
  ...portfolioEditTranslationsNl,
  ...localizationSupportTranslationsNl,
  ...uiPaginationTranslationsNl
};
const portfolioListTranslationsBundle = {
  de: portfolioListTranslationsDe,
  en: portfolioListTranslationsEn,
  es: portfolioListTranslationsEs,
  fr: portfolioListTranslationsFr,
  it: portfolioListTranslationsIt,
  nl: portfolioListTranslationsNl
};

export { portfolioListTranslationsBundle, portfolioListTranslationsDe, portfolioListTranslationsEn, portfolioListTranslationsEs, portfolioListTranslationsFr, portfolioListTranslationsIt, portfolioListTranslationsNl };
